import { render, staticRenderFns } from "./Christmas_foodItem.vue?vue&type=template&id=1d6565e2&scoped=true"
import script from "./Christmas_foodItem.vue?vue&type=script&lang=ts"
export * from "./Christmas_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./Christmas_foodItem.vue?vue&type=style&index=0&id=1d6565e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6565e2",
  null
  
)

export default component.exports